import {flow} from 'vendor';

export const type = ({ dailyRoutineId, habitTypeId, repeatType, isTemplate, repeatCount, isRecurring, repeatDays, name  } = {}) => {
  if (isTemplate) {
    return 'template';
  } else if (repeatCount == 1 && repeatType == 'Weekly' && !repeatDays || isRecurring && !repeatCount && !repeatDays && !repeatType) {
    return 'example';
  } else if (dailyRoutineId > 0) {
    return 'subroutine';
  } else if (habitTypeId > 0) {
    return 'habit';
  } else if (repeatType) {
    return 'routine';
  } else {
    return 'activity';
  }
}

export const pluralType = flow(type, type => type == 'activity' ? 'activities' : type + 's');

export const isPredefined = flow(type, type => type == 'example' || type == 'template');
